import { render, staticRenderFns } from "./sales-order-view.vue?vue&type=template&id=2b87b6e8&scoped=true&"
import script from "./sales-order-view.vue?vue&type=script&lang=js&"
export * from "./sales-order-view.vue?vue&type=script&lang=js&"
import style0 from "./sales-order-view.vue?vue&type=style&index=0&id=2b87b6e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87b6e8",
  null
  
)

export default component.exports